import { defineStore } from 'pinia'
import { MediaItemData } from '@/views/YoyaEdit/components/types/TrackList'
export interface ActiveVoice {
	[key: string]: any // 支持任意字符串键名
	auditionUrl: string
	avatarUrl: string
	concatenated: string
	isPlay: boolean
	name: string
	nickName: string
	sex: number
	speed: number
	status: number
	type: number
	typeName: string
	voiceId: string
	voiceNum: number
}
export interface ActiveBackgroundAudio {
	[key: string]: any // 支持任意字符串键名
	audioId: number
	audioVolume: number
	duration: number
	isPlay: boolean
	remark: string
	type: number
	url?: string
	audioUrl?: string
}

export interface ActiveAIHuman {
	[key: string]: any // 支持任意字符串键名
	id: string
	name: string
	url: string
	x: number // 位置x
	y: number // 位置y
	scale: number // 缩放
	show: boolean
}

export const useVideoEditorStore = defineStore('videoEditorStore', {
	state: () => ({
		draftId: '',
		taskId: '',
		title: '',
		totalDuration: 0, // 总时长
		videoCombing: false, // 视频正在合成
		showHistory: true, // 是否显示历史
		selectMediaShow: false, // 是否显示选择媒体
		renderStatus: false, // 上轨状态
		taskLoading: false, // 上轨loading
		onlyTrackListLoading: false, // 只显示loading
		playing: false,
		showRender: false,
		draftType: 0, // 1:极速成片 2:视频转译 3:素材成片 4:  5: mv
		// 共享数据 当前活动的音频
		activeVoice: {
			auditionUrl: 'https://sourceyoya.wenge.com/voice_moyin/xiaoqi_meet_24k.wav',
			avatarUrl: 'http://source.wengegroup.com/bucket-ai-anchor/male_avatar_colorful.png',
			concatenated: '千尚-男-新闻',
			isPlay: false,
			name: 'xiaoqi_meet_24k',
			nickName: '千尚',
			sex: 1,
			speed: 1,
			status: 1,
			type: 1,
			typeName: '新闻',
			voiceId: '223',
			voiceNum: 50
		} as ActiveVoice,

		activeBackgroundAudio: {
			audioId: 0,
			audioVolume: 50,
			duration: 0,
			isPlay: false,
			remark: '',
			type: 1,
			url: ''
		} as ActiveBackgroundAudio,

		activeAIHuman: {
			show: false,
			id: '',
			name: '',
			url: '',
			x: 0, // 位置x
			y: 0, // 位置y
			scale: 1, // 缩放
			resolution: '' // 分辨率
		} as ActiveAIHuman,

		// 视频比例
		videoRatio: '16:9',
		activeImage: {} as MediaItemData
	}),

	actions: {
		setVideoCombing(val: boolean) {
			this.videoCombing = val
		},
		setShowHistory(val: boolean) {
			this.showHistory = val
		},
		setSelectMediaShow(val: boolean) {
			this.selectMediaShow = val
		},
		setRenderStatus(val: boolean) {
			this.renderStatus = val
		},
		setTaskLoading(val: boolean) {
			this.taskLoading = val
		},
		setOnlyTrackListLoading(val: boolean) {
			this.onlyTrackListLoading = val
		},
		setActiveVoice(key: string, val: any) {
			this.activeVoice[key] = val
		},
		setActiveBackgroundAudio(key: string, val: any) {
			this.activeBackgroundAudio[key] = val
		},
		setActiveAIHuman(key: string, val: any) {
			this.activeAIHuman[key] = val
		},
		setTotalDuration(val: number) {
			this.totalDuration = val
		},
		setDraftId(val: string) {
			this.draftId = val
		},
		setTaskId(val: string) {
			this.taskId = val
		},
		setTitle(val: string) {
			this.title = val
		},
		setPlaying(val: boolean) {
			this.playing = val
		},
		setShowRender(val: boolean) {
			this.showRender = val
		},
		setDraftType(val: number) {
			this.draftType = val
		},
		setActiveImage(data: MediaItemData) {
			this.activeImage = data
		},
		resetAIHuman() {
			this.activeAIHuman.show = false
			this.activeAIHuman.id = ''
			this.activeAIHuman.name = ''
			this.activeAIHuman.url = ''
			this.activeAIHuman.x = 0
			this.activeAIHuman.y = 0
			this.activeAIHuman.scale = 1
		},
		resetActiveImage() {
			this.activeImage = {} as MediaItemData
		},
		// 重置所有数据到初始状态
		resetStore() {
			this.draftId = ''
			this.taskId = ''
			this.title = ''
			this.totalDuration = 0
			this.videoCombing = false
			this.showHistory = true
			this.selectMediaShow = false
			this.renderStatus = false
			this.taskLoading = false
			this.onlyTrackListLoading = false
			this.playing = false
			this.showRender = false
			this.activeVoice = {
				auditionUrl: 'https://sourceyoya.wenge.com/voice_moyin/xiaoqi_meet_24k.wav',
				avatarUrl: 'http://source.wengegroup.com/bucket-ai-anchor/male_avatar_colorful.png',
				concatenated: '千尚-男-新闻',
				isPlay: false,
				name: 'xiaoqi_meet_24k',
				nickName: '千尚',
				sex: 1,
				speed: 1,
				status: 1,
				type: 1,
				typeName: '新闻',
				voiceId: '223',
				voiceNum: 50
			} as ActiveVoice
			this.activeBackgroundAudio = {
				audioId: 0,
				audioVolume: 50,
				duration: 0,
				isPlay: false,
				remark: '',
				type: 1,
				url: ''
			} as ActiveBackgroundAudio
			this.activeImage = {} as MediaItemData
			this.resetAIHuman()
			// this.videoRatio = '16:9'
		},
		setVideoRatio(val: string) {
			this.videoRatio = val
		}
	},
	getters: {
		getVideoCombing: state => state.videoCombing,
		getShowHistory: state => state.showHistory,
		getSelectMediaShow: state => state.selectMediaShow,
		getRenderStatus: state => state.renderStatus,
		getTaskLoading: state => state.taskLoading,
		getOnlyTrackListLoading: state => state.onlyTrackListLoading,
		getActiveVoice: state => (key: string) => state.activeVoice[key],
		getActiveBackgroundAudio: state => (key: string) => state.activeBackgroundAudio[key],
		getActiveAIHuman: state => (key: string) => state.activeAIHuman[key],
		getTotalDuration: state => state.totalDuration,
		getDraftId: state => state.draftId,
		getTaskId: state => state.taskId,
		getTitle: state => state.title,
		getPlaying: state => state.playing,
		getShowRender: state => state.showRender,
		getDraftType: state => state.draftType,
		getVideoRatio: state => state.videoRatio,
		getActiveImage: state => state.activeImage
	}
})
